"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentObjectSchema = exports.AttachmentReferenceObjectSchema = void 0;
const zod_1 = __importDefault(require("zod"));
exports.AttachmentReferenceObjectSchema = zod_1.default
    .object({
    kind: zod_1.default.literal('reference'),
    type: zod_1.default.enum(['submission'], {
        description: 'type of entity referenced',
    }),
    id: zod_1.default.string({ description: 'id of referenced entity' }),
})
    .openapi('AttachmentReferenceObject');
exports.AttachmentObjectSchema = exports.AttachmentReferenceObjectSchema;
//# sourceMappingURL=attachmentSchema.js.map